import axios from 'axios';
import { isDemoUser, getDemoUrl } from './demoConfig';

// Intercept all axios requests: rewrite URLs for demo user OR admin viewing DEMO supplier
axios.interceptors.request.use((config) => {
  const isDemo = isDemoUser() ||
    (config.data && typeof config.data === 'object' && config.data.supplier === 'DEMO');
  if (isDemo && config.url) {
    if (
      config.url.includes('/rep_sales/') ||
      config.url.includes('/rep_strikeRate/') ||
      config.url.includes('/rep_ranging/') ||
      config.url.includes('/rep_margin/')
    ) {
      config.url = getDemoUrl(config.url);
    }
  }
  return config;
});
